/*****************************************************************************
 * PROJECT NAME   : SEC 회의실관리 프로젝트
 * SUBSYSTEM NAME : 모바일지갑 웹뷰
 * FILE NAME      : mixins.js
 * DESCRIPTION    : 공통 메소드를 정의하는 믹스인 파일
 *
 * VERSION NO     author           date        content  -> info
 * ----------------------------------------------------------------------------
 *    1.0       K.Hur      2021-09-27      init
 *****************************************************************************/

// import axios from 'axios'

export default {
  methods: {
    $checkAjaxResult (response) {
      if(!response) return

      this.$store.commit('hideLoading')
  
      if(response.data.authorityYn && response.data.authorityYn == 'N') {
        document.location.href = '/error/nonePermission'
        // alert('해당요청의 권한이 없습니다.')
        return false
      }
      else if(response.data.authenticationYn && response.data.authenticationYn == 'N' && response.data.dbtoken == 'fail') {
        this.$showErrorMsg('토큰검증이 실패하였습니다.')
        // document.location.href = '/error/401'
        // document.location.href = '/secl/user/login'
            
        return false
      }
      else if(response.data.authenticationYn && response.data.authenticationYn == 'N') {

        //토큰관련 예외는 무조건 재발급처리 -> 만료되면 콜백에서 로그인이동
        this.$refresh()
            
        return false
      }
      else if(response.data.accessDeniedYn && response.data.accessDeniedYn == 'N') {
        document.location.href = '/error/403'
        return false
      }
      else if(response.data.successYn == 'N') {
        if(response.data.message){
          alert(response.data.message)
        }
        else{
          alert('요청중 오류가 발생하였습니다($checkAjaxResult)')
        }
        return false
      }

      return true
    },
    $showErrorMsg (msg) {
      if(msg){
        alert(msg)
        return
      }
      alert('요청중 오류가 발생하였습니다(showErrorMsg)')
    },
    $showMsg (msg) {
      alert(`${msg}`)
    },
    $confirmMsg (msg) {
      if(!confirm(msg))
        return false
      else
        return true
    },

	
    

    //코드명가져오기
		$getCodeNm(lst, code){
			let codeNm = 'N/A'
      try {
        codeNm = lst.filter((row)=> row.cd == code).map((row) => row.nm)[0]
      } catch  {()=>{}}
			
			return codeNm
		},		    

    //NVL처리
		$nvl(str, rep){
      if(!str || str == undefined || str == 'undefined' )  
        return rep
      else  
        return str
    },
		$nvl2(str, rep, str2){
      if(!str || str == undefined || str == 'undefined' )  
        return rep
      else  
        return str2
    },

    $lpad(_s, padLength, padString){
      let s = new String(_s)
      while(s.length < padLength)
          s = padString + s;
      return s;
    },

    $rpad(_s, padLength, padString){
      let s = new String(_s)
      while(s.length < padLength)
          s += padString;
      return s;
    },

    $isNull(str) {
      if (str == null)
        return true;
      if (str == "NaN")
        return true;
      if (new String(str).valueOf().replace(/-/g,"").search("undef") > -1)
        return true;
      var chkStr = new String(str);
      if (chkStr.valueOf().replace(/-/g,"").search("undef") > -1)
        return true;
      if (chkStr == null)
        return true;
      if (chkStr.toString().length == 0)
        return true;
      return false;
    },


    /**
     * 문자열 len 만큼 줄이고 ..
     * @param {*} str 
     * @param {*} len 
     * @returns 
     */
    $lenStr(str, len){
        // 영문이면 길이1.5배까지 허용
        if(/^[A-za-z0-9&#\-/ ]+$/.test(str))
          len = Math.floor(len*1.5)

        let ret = '';
        try {
            if(str.length > len){
                // ret = str.substring(0,len) + '..';
                ret = str.slice(0,len) + '..';
            }
            else{
                ret = str;
            }
        } catch (error) {
            return ret;
        }
        return ret;
    },    

    //기본좌석배열 세팅
    // $setLayUsr(ary, cnt){

    //   //기본좌석배열
    //   ary = []
    //   for(let i=1; i <= cnt; i++){
    //     ary.push({seat: `${i}` ,userId: '', name: ' ', rank: '', department: ''})
    //   }	

    //   return ary
    // }


    // 토큰재발급
    async $refresh() {

      this.$store.commit('showLoading')

      let response 
      try {
        response = await this.axios ({
          method: 'POST',
          url: MYDATA_CONFIG.API_DOMAIN + '/api/v1/refresh',
          data: {}
        })
      } catch (error) {
        // console.log(`error ----- ${error}`)        
        // alert(`토큰이 만료되었습니다. 다시 로그인해주십시오.`)
        this.$router.push(`/secl/user/login`)
      }
      
      //응답처리
      if(!this.$checkAjaxResult(response)) {
        return
      }

      //사용자정보 store에 저장
      console.log(`response.headers.accesstoken - ${JSON.stringify(response.headers.accesstoken) }`)
      try {
        // alert(`토큰이 정상적으로 재발급되었습니다.`)

        // 토큰저장
        // this.$store.commit('SET_accesstoken', response.headers.accesstoken)
        sessionStorage.setItem('atoken',`${response.headers.accesstoken}`)
      
        // 원래요청했던 페이지 로딩
        // console.log(`this.$router.currentRoute.value.path - ${this.$router.currentRoute.value.path}`)
        // this.$router.push(`${this.$router.currentRoute.value.path}`)
        this.$router.go() //reload
        
      } catch {()=>{}}
      finally{() => {
        this.$store.commit('hideLoading')
      }}
    },
    

    // 파일 다운로드 공통
		$downloadFile(url){
			this.$store.commit('showLoading')

			this.axios ({
				method: 'GET',
				url: MYDATA_CONFIG.API_DOMAIN + url,
				headers: {
					'X-Requested-With': 'xmlhttprequest'
				},
				responseType: 'blob',
				data: {}
			}).then ((response) => {
				let tmp = `${response.headers['content-disposition']}`
				let fname = tmp.slice(tmp.indexOf('filename=')+9).replace(/"/g,'')
				fname = decodeURI(fname,'UTF-8').replace(/\+/g,' ') //한글디코딩
				try {
					console.log(`response.data - ${response.data}`)
					// href 링크처리
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', fname); //or any other extension
					document.body.appendChild(link);
					link.click();

				} catch{(e)=>{
					console.log(`성공응답 error - ${e}`)
				}}
				
			}).catch(error => {
				this.$showErrorMsg(error)
			}).finally(() => {
				this.$store.commit('hideLoading')
			})
		},

  },


  data(){
    return{
      /**
       * 공통코드를 추가할수 없어서 전역변수로 선언함
       */

			g_prc_cds:[
				{cd:'01', nm:'예정'},
				{cd:'02', nm:'회의중'},
				{cd:'03', nm:'종료'},
			],


      g_style: `
      <style>\n
      .table{width: 100%; border: 1px solid #000;}\n
      
      .excelHeadColumn   {border-top: 3px solid #000;border-bottom: 2px solid #999999; height:32px;text-align: center; background-color: #f5f7f9;}\n
      .excelHeadColumnReq   {border-top: 3px solid #000;border-bottom: 2px solid #999999; height:32px;text-align: center; background-color: #FFBB00; }\n
      
      .excelBodyColumn50 {border: 1px solid #ddd; text-align: center; width : 50px;}}\n
      .excelBodyColumn100{border: 1px solid #ddd; text-align: center; width : 100px;}\n
      .excelBodyColumn150{border: 1px solid #ddd; text-align: center; width : 150px;}\n
      .excelBodyColumn200{border: 1px solid #ddd; text-align: center; width : 200px;}\n
      .excelBodyColumn250{border: 1px solid #ddd; text-align: center; width : 250px;}\n
      .excelBodyColumn300{border: 1px solid #ddd; text-align: center; width : 300px;}\n
      .excelBodyColumn600{border: 1px solid #ddd; text-align: center; width : 600px;}\n
      .excelBodyColumn700{border: 1px solid #ddd; text-align: center; width : 700px;}\n
      
      .excelBodyColumnStart50 {border: 1px solid #ddd; text-align: start; width : 50px;}}\n
      .excelBodyColumnStart100{border: 1px solid #ddd; text-align: start; width : 100px;}\n
      .excelBodyColumnStart150{border: 1px solid #ddd; text-align: start; width : 150px;}\n
      .excelBodyColumnStart200{border: 1px solid #ddd; text-align: start; width : 200px;}\n
      .excelBodyColumnStart250{border: 1px solid #ddd; text-align: start; width : 250px;}\n
      .excelBodyColumnStart300{border: 1px solid #ddd; text-align: start; width : 300px;}\n
      .excelBodyColumnStart600{border: 1px solid #ddd; text-align: start; width : 600px;}\n
      .excelBodyColumnStart700{border: 1px solid #ddd; text-align: start; width : 700px;}\n
      
      .excelBodyColumnEnd50 {border: 1px solid #ddd; text-align: end; width : 50px;}}\n
      .excelBodyColumnEnd100{border: 1px solid #ddd; text-align: end; width : 100px;}\n
      .excelBodyColumnEnd150{border: 1px solid #ddd; text-align: end; width : 150px;}\n
      .excelBodyColumnEnd200{border: 1px solid #ddd; text-align: end; width : 200px;}\n
      .excelBodyColumnEnd250{border: 1px solid #ddd; text-align: end; width : 250px;}\n
      .excelBodyColumnEnd300{border: 1px solid #ddd; text-align: end; width : 300px;}\n
      .excelBodyColumnEnd600{border: 1px solid #ddd; text-align: end; width : 600px;}\n
      .excelBodyColumnEnd700{border: 1px solid #ddd; text-align: end; width : 700px;}\n
      
      .excelBodyColumnEven50 {border: 1px solid #ddd; text-align: center; width : 50px;}\n
      .excelBodyColumnEven100{border: 1px solid #ddd; text-align: center; width : 100px;}\n
      .excelBodyColumnEven150{border: 1px solid #ddd; text-align: center; width : 150px;}\n
      .excelBodyColumnEven200{border: 1px solid #ddd; text-align: center; width : 200px;}\n
      .excelBodyColumnEven250{border: 1px solid #ddd; text-align: center; width : 250px;}\n
      .excelBodyColumnEven300{border: 1px solid #ddd; text-align: center; width : 300px;}\n
      .excelBodyColumnEven600{border: 1px solid #ddd; text-align: center; width : 600px;}\n
      .excelBodyColumnEven700{border: 1px solid #ddd; text-align: center; width : 700px;}\n
      
      .excelBodyColumnEvenStart50 {border: 1px solid #ddd; text-align: start; width : 50px;}}\n
      .excelBodyColumnEvenStart100{border: 1px solid #ddd; text-align: start; width : 100px;}\n
      .excelBodyColumnEvenStart150{border: 1px solid #ddd; text-align: start; width : 150px;}\n
      .excelBodyColumnEvenStart200{border: 1px solid #ddd; text-align: start; width : 200px;}\n
      .excelBodyColumnEvenStart250{border: 1px solid #ddd; text-align: start; width : 250px;}\n
      .excelBodyColumnEvenStart300{border: 1px solid #ddd; text-align: start; width : 300px;}\n
      .excelBodyColumnEvenStart600{border: 1px solid #ddd; text-align: start; width : 600px;}\n
      .excelBodyColumnEvenStart700{border: 1px solid #ddd; text-align: start; width : 700px;}\n
      
      .excelBodyColumnEvenEnd50 {border: 1px solid #ddd; text-align: end; width : 50px;}}\n
      .excelBodyColumnEvenEnd100{border: 1px solid #ddd; text-align: end; width : 100px;}\n
      .excelBodyColumnEvenEnd150{border: 1px solid #ddd; text-align: end; width : 150px;}\n
      .excelBodyColumnEvenEnd200{border: 1px solid #ddd; text-align: end; width : 200px;}\n
      .excelBodyColumnEvenEnd250{border: 1px solid #ddd; text-align: end; width : 250px;}\n
      .excelBodyColumnEvenEnd300{border: 1px solid #ddd; text-align: end; width : 300px;}\n
      .excelBodyColumnEvenEnd600{border: 1px solid #ddd; text-align: end; width : 600px;}\n
      .excelBodyColumnEvenEnd700{border: 1px solid #ddd; text-align: end; width : 700px;}\n
      
      .excelSubTitle{font-size: 1.2em;text-align: right;}\n
      .excelMainTitle{font-size: 2.5em;}\n

      .noBody100{border: 0px; width : 100px;}\n
      </style>      
      `,
      
    }
  },


}
